import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ lightbox, onClose, onNav }) => {
  const { shots, index, name } = lightbox;

  const prev = useCallback(
    () => onNav((index - 1 + shots.length) % shots.length),
    [index, shots.length, onNav]
  );
  const next = useCallback(() => onNav((index + 1) % shots.length), [index, shots.length, onNav]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, prev, next]);

  const navBtn =
    "absolute top-1/2 -translate-y-1/2 p-3 text-[#F7F5F0]/70 hover:text-[#C29B62] transition-colors";

  return (
    <div
      data-testid="lightbox"
      className="fixed inset-0 z-[70] bg-[#101f17]/95 backdrop-blur-sm flex items-center justify-center"
      onClick={onClose}
    >
      <button
        type="button"
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-6 right-6 p-2 text-[#F7F5F0]/70 hover:text-[#C29B62] transition-colors"
        aria-label="Chiudi"
      >
        <X className="w-7 h-7" />
      </button>
      {shots.length > 1 && (
        <button
          type="button"
          data-testid="lightbox-prev"
          onClick={(e) => { e.stopPropagation(); prev(); }}
          className={`${navBtn} left-2 lg:left-8`}
          aria-label="Precedente"
        >
          <ChevronLeft className="w-9 h-9" />
        </button>
      )}
      <figure onClick={(e) => e.stopPropagation()} className="max-w-5xl w-full px-14 lg:px-20">
        <img
          src={shots[index]}
          alt={`${name} — foto ${index + 1}`}
          data-testid="lightbox-image"
          className="w-full max-h-[80vh] object-contain"
        />
        <figcaption className="mt-4 text-center text-xs uppercase tracking-[0.25em] text-[#F7F5F0]/60">
          {name} · {index + 1} / {shots.length}
        </figcaption>
      </figure>
      {shots.length > 1 && (
        <button
          type="button"
          data-testid="lightbox-next"
          onClick={(e) => { e.stopPropagation(); next(); }}
          className={`${navBtn} right-2 lg:right-8`}
          aria-label="Successiva"
        >
          <ChevronRight className="w-9 h-9" />
        </button>
      )}
    </div>
  );
};
